import { useEffect, useState } from "react";

const DESKTOP_MIN_WIDTH = 815;

const checkIsDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;

export function useDesktop() {
	const [isDesktop, setIsDesktop] = useState(checkIsDesktop());

	useEffect(() => {
		const listener = () => {
			setIsDesktop(checkIsDesktop());
		};
		window.addEventListener("resize", listener);

		return () => window.removeEventListener("resize", listener);
	}, []);

	return isDesktop;
}
